"use strict";
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.BDIGGOracleFactory = void 0;
var contracts_1 = require("@ethersproject/contracts");
var BDIGGOracleFactory = /** @class */ (function (_super) {
    __extends(BDIGGOracleFactory, _super);
    function BDIGGOracleFactory(signer) {
        return _super.call(this, _abi, _bytecode, signer) || this;
    }
    BDIGGOracleFactory.prototype.deploy = function (overrides) {
        return _super.prototype.deploy.call(this, overrides || {});
    };
    BDIGGOracleFactory.prototype.getDeployTransaction = function (overrides) {
        return _super.prototype.getDeployTransaction.call(this, overrides || {});
    };
    BDIGGOracleFactory.prototype.attach = function (address) {
        return _super.prototype.attach.call(this, address);
    };
    BDIGGOracleFactory.prototype.connect = function (signer) {
        return _super.prototype.connect.call(this, signer);
    };
    BDIGGOracleFactory.connect = function (address, signerOrProvider) {
        return new contracts_1.Contract(address, _abi, signerOrProvider);
    };
    return BDIGGOracleFactory;
}(contracts_1.ContractFactory));
exports.BDIGGOracleFactory = BDIGGOracleFactory;
var _abi = [
    {
        inputs: [],
        payable: false,
        stateMutability: "nonpayable",
        type: "constructor",
    },
    {
        constant: true,
        inputs: [],
        name: "DIGG",
        outputs: [
            {
                internalType: "contract BaseERC20",
                name: "",
                type: "address",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "bDIGG",
        outputs: [
            {
                internalType: "contract IBadgerSett",
                name: "",
                type: "address",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "btcUsdChainlinkOracle",
        outputs: [
            {
                internalType: "contract IChainLinkAggregator",
                name: "",
                type: "address",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "btcUsdChainlinkScalar",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "diggBtcChainlinkOracle",
        outputs: [
            {
                internalType: "contract IChainLinkAggregator",
                name: "",
                type: "address",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "diggBtcChainlinkScalar",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "diggScalar",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "fetchCurrentPrice",
        outputs: [
            {
                components: [
                    {
                        internalType: "uint256",
                        name: "value",
                        type: "uint256",
                    },
                ],
                internalType: "struct Decimal.D256",
                name: "",
                type: "tuple",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
];
var _bytecode = "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";
